var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisposable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.116 30.993c-.039 0-.077.007-.116.007s-.077-.007-.116-.007l-.776 6.2a144.29 144.29 0 0 0 -1.108 17.807 2 2 0 0 0 4 0 144.29 144.29 0 0 0 -1.108-17.807z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41 29c2.79 0 5.134-2.555 5.8-6h-11.6c.666 3.445 3.01 6 5.8 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23 29c3.309 0 6-3.589 6-8s-2.691-8-6-8-6 3.589-6 8 2.691 8 6 8zm0-14c2.243 0 4 2.636 4 6h-2c0-2.29-1.056-4-2-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.116 30.993c-.039 0-.077.007-.116.007s-.077-.007-.116-.007l-.776 6.2a144.29 144.29 0 0 0 -1.108 17.807 2 2 0 0 0 4 0 144.29 144.29 0 0 0 -1.108-17.807z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m48 4-4-2-4 2-4-2-4 2-4-2-4 2-4-2-4 2-4-2v5h40v-5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12 57a5 5 0 0 0 5 5h30a5 5 0 0 0 5-5v-48h-40zm21-46h2v10h3v-10h2v10h2v-10h2v10h3v-10h2v10c0 4.61-2.512 8.49-5.912 9.643l.788 6.3a146.146 146.146 0 0 1 1.124 18.057 4 4 0 0 1 -8 0 146.146 146.146 0 0 1 1.124-18.055l.788-6.3c-3.4-1.155-5.912-5.035-5.912-9.645zm-10 0c4.411 0 8 4.486 8 10 0 4.61-2.512 8.49-5.912 9.643l.788 6.3a146.146 146.146 0 0 1 1.124 18.057 4 4 0 0 1 -8 0 146.146 146.146 0 0 1 1.124-18.055l.788-6.3c-3.4-1.155-5.912-5.035-5.912-9.645 0-5.514 3.589-10 8-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisposable);
export default __webpack_public_path__ + "static/media/disposable.fd710c3df100ed8d67e692f531d032d4.svg";
export { ForwardRef as ReactComponent };